import React from 'react'
import ProfileSecurity from 'src/app/ProfileSecurity/ProfileSecurity'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { profileSecurityRouteProps } from 'src/navigation/routeProps'

const ProfileSecurityAppRoute: AppRoute = {
  id: AppLocation.ProfileSecurity,
  routeProps: profileSecurityRouteProps,
  component: <ProfileSecurity />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileSecurityAppRoute
